import { useLang } from "../../lib/i18n";

export const RangeSelect = ({ value, onChange }) => {
  const { t } = useLang();
  return (
    <div className="inline-flex rounded-full border border-slate-200 bg-white p-1" data-testid="insights-range">
      {[7, 30, 90].map((n) => (
        <button key={n} type="button" onClick={() => onChange(n)} data-testid={`insights-range-${n}`}
          className={`rounded-full px-4 py-1.5 text-sm font-semibold transition-colors duration-200 ${
            value === n ? "bg-slate-900 text-white" : "text-slate-600 hover:text-slate-900"}`}>
          {n} {t("ins_days")}
        </button>
      ))}
    </div>
  );
};
